import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import * as SActions from 'ApplicationEntry/ducks/ProductsRiders/shop';
import * as S from 'ApplicationEntry/models/ProductsRiders/Shop/OrdinaryShop';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import * as ErrorMessages from '../../ErrorMessages';
import './Shop.sass';
import FixedCodeRiderInformation from '../FixedCodeRiderInformation';

type ShopProps = {
  shop: S.OrdShop;
};

const Shop = (props: ShopProps) => {
  const dispatch = useDispatch();
  const {planType, cwa, section125, selectCGI, baseUnit, calculatedPremium, riderInformation} = props.shop;

  const [planTypeBlurred, setBlurPlanType] = useState(false);
  const [planTypeLabel, setPlanTypeLabel] = useState<HTMLLabelElement | null>();
  const [baseUnitsLabel, setBasenitsLabel] = useState<HTMLLabelElement | null>();
  const showPlanTypeError = planTypeBlurred && planType.key === 'Empty';

  return (
    <div className="shop-section" id="shop-section">
      <form noValidate autoComplete="off" className="shop-section__form">
        <div className="shop-section__form-row">
          <Grid container spacing={4}>
            <Grid item xs={12} md={3}>
              <FormControl error={showPlanTypeError} variant="outlined" className="shop-section__form-text-field">
                <InputLabel ref={setPlanTypeLabel} id="shop-plantype-label">
                  Plan Type
                </InputLabel>
                <Select
                  labelId="shop-label-plantype"
                  labelWidth={planTypeLabel?.clientWidth}
                  id="shop-plantype"
                  value={planType.key === 'Empty' ? '' : planType.value}
                  onBlur={() => setBlurPlanType(true)}
                  onChange={event => dispatch(SActions.changePlanType(event.target.value as string))}
                  displayEmpty
                >
                  <MenuItem value="IND">Individual</MenuItem>
                  <MenuItem value="FAMILY">Family</MenuItem>
                  <MenuItem value="INDSPS">Ind+Sp</MenuItem>
                  <MenuItem value="INDCH">Ind+Ch</MenuItem>
                </Select>
                {showPlanTypeError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl variant="outlined" className="shop-section__form-text-field">
                <InputLabel ref={setBasenitsLabel} id="shop-baseUnits-label">
                  Base Units
                </InputLabel>
                <Select
                  labelId="shop-label-baseUnits"
                  labelWidth={baseUnitsLabel?.clientWidth}
                  id="shop-baseUnits"
                  value={baseUnit === -1 ? '' : baseUnit}
                  onChange={event => dispatch(SActions.changeBaseUnit(event.target.value as number))}
                  displayEmpty
                >
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={6}>6</MenuItem>
                  <MenuItem value={7}>7</MenuItem>
                  <MenuItem value={8}>8</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="secondary"
                    checked={selectCGI}
                    onChange={() => dispatch(SActions.changeSelectCGI(!selectCGI))}
                    name="checkedB"
                  />
                }
                label="Select CGI"
                className="shop-section__form-checkbox"
              />
            </Grid>
          </Grid>
          
          <FixedCodeRiderInformation
            riderInformation={riderInformation}
            changeRiderInformationAction={SActions.changeRiderInformation}
            identifier={'ordinary-shop'}
          />
          
          <div className="shop-section__sub-title-container">
            <Typography variant="subtitle1" className="shop-section__sub-title-container-title">
              Additional Information
            </Typography>
          </div>

          <Grid container spacing={4}>
            <Grid item xs={12} md={3}>
              <TextField
                id="shop-premium"
                label="Premium"
                variant="outlined"
                placeholder="Premium"
                margin="normal"
                fullWidth
                className="shop-section__form-text-field"
                value={calculatedPremium.key === 'Empty' ? '' : calculatedPremium.value}
                onChange={event => {
                  dispatch(SActions.changePremium(event.target.value as string));
                  dispatch(SActions.changeCalculatedPremium(event.target.value as string));
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                id="shop-cwa"
                label="CWA"
                variant="outlined"
                placeholder="CWA"
                margin="normal"
                fullWidth
                className="shop-section__form-text-field"
                value={cwa.key === 'Empty' ? '' : cwa.value}
                onChange={event => dispatch(SActions.changeCWA(event.target.value as string))}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="checkedB"
                    color="secondary"
                    id="shop-section-125"
                    checked={section125}
                    onChange={() => dispatch(SActions.changeSection125(!section125))}
                  />
                }
                label={<Typography>Section 125</Typography>}
                className="shop-section__form-text-field"
              />
            </Grid>
          </Grid>
        </div>
      </form>
    </div>
  );
};

export default Shop;
